export default __webpack_public_path__ + "static/media/Mariners.4dd0d87e.png";